import { PartnershipTier, PartnershipTierLevel } from '@urbanx/agx.agencies.client';

export const defaultPartnershipTemplates: PartnershipTier[] = [
  {
    level: PartnershipTierLevel.Bronze,
    minimumGci: 0,
    maximumGci: 249999,
    serviceFeePercentage: 30,
  },
  {
    level: PartnershipTierLevel.Silver,
    minimumGci: 250000,
    maximumGci: 499999,
    serviceFeePercentage: 25,
  },
  {
    level: PartnershipTierLevel.Gold,
    minimumGci: 500000,
    maximumGci: 999999,
    serviceFeePercentage: 20,
  },
  {
    level: PartnershipTierLevel.Platinum,
    minimumGci: 1000000,
    maximumGci: 1999999,
    serviceFeePercentage: 15,
  },
  {
    level: PartnershipTierLevel.XPartner,
    minimumGci: 2000000,
    maximumGci: undefined,
    serviceFeePercentage: 10,
  },
];
